import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect } from "react";
import { getOptionsFromWindow, isCustomize } from "../utils";
import { getCookieConsentManager } from "../others";
import { preDecisionGateway } from "@devowl-wp/cookie-consent-web-client";
import { preDecisionGatewayDynamicRequest, preDecisionGatewayHasPageClass, preDecisionGatewayIsCrawler, preDecisionGatewayIsPreventPreDecision, preDecisionGatewaySupportsCookies, preDecisionGatewayUserConsent, preDecisionGatewayIsDoNotTrack } from "@devowl-wp/cookie-consent-web-client";
import { commonRequest } from "@devowl-wp/utils";
import { locationRestConsentDynamicPredecisionGet } from "../wp-api";
import { isHiddenDueLegal } from "@devowl-wp/react-cookie-banner";
/**
 * Do some decision gateways like DNT, Bot / Crawler and Decision and depending
 * on that, show the Banner initially.
 */

function useBannerPreDecisionGateway(banner, setContextValue, toggleOverlay) {
  useEffect(function () {
    // Only run this predecision mechanism once and when not in customize
    if (isCustomize()) {
      return;
    }

    var _getOptionsFromWindow = getOptionsFromWindow(),
        restNamespace = _getOptionsFromWindow.restNamespace,
        restRoot = _getOptionsFromWindow.restRoot,
        restQuery = _getOptionsFromWindow.restQuery,
        restNonce = _getOptionsFromWindow.restNonce,
        _getOptionsFromWindow2 = _getOptionsFromWindow.others,
        isAcceptAllForBots = _getOptionsFromWindow2.isAcceptAllForBots,
        isPreventPreDecision = _getOptionsFromWindow2.isPreventPreDecision,
        hasDynamicPreDecisions = _getOptionsFromWindow2.hasDynamicPreDecisions,
        isRespectDoNotTrack = _getOptionsFromWindow2.isRespectDoNotTrack;

    var onSave = banner.onSave;
    preDecisionGateway(getCookieConsentManager(), {
      gateways: [preDecisionGatewaySupportsCookies, preDecisionGatewayHasPageClass(["login-action-"]), preDecisionGatewayDynamicRequest(function () {
        var _document$documentEle = document.documentElement,
            clientWidth = _document$documentEle.clientWidth,
            clientHeight = _document$documentEle.clientHeight;
        return commonRequest({
          location: locationRestConsentDynamicPredecisionGet,
          options: {
            restNamespace: restNamespace,
            restRoot: restRoot,
            restQuery: restQuery,
            restNonce: restNonce
          },
          sendRestNonce: false,
          request: {
            viewPortWidth: clientWidth,
            viewPortHeight: clientHeight
          },
          params: {
            _wp_http_referer: window.location.href
          }
        });
      }, 10000, hasDynamicPreDecisions), /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, banner) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", isHiddenDueLegal(banner) ? "consent" : false);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }(), preDecisionGatewayIsPreventPreDecision(isPreventPreDecision), preDecisionGatewayIsCrawler(isAcceptAllForBots ? "all" : false), preDecisionGatewayIsDoNotTrack(isRespectDoNotTrack), preDecisionGatewayUserConsent],
      args: [banner],
      onIsDoNotTrack: function onIsDoNotTrack() {
        onSave(true, "none");
      },
      onShowCookieBanner: function onShowCookieBanner() {
        return setContextValue(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            // Always revert back to "Essentials" only consent when cookie needs to be consented
            consent: {
              groups: getCookieConsentManager().getDefaultDecision()
            }
          }, toggleOverlay(state, true));
        });
      }
    });
  }, []);
}

export { useBannerPreDecisionGateway };